import { render, staticRenderFns } from "./ContentWithSideMenu.vue?vue&type=template&id=60dbbaee&scoped=true&"
import script from "./ContentWithSideMenu.vue?vue&type=script&lang=js&"
export * from "./ContentWithSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentWithSideMenu.vue?vue&type=style&index=0&id=60dbbaee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dbbaee",
  null
  
)

export default component.exports